import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../api/api";
import PostApi from "../../api/PostApi";
import { showAlert } from "../../actions";
import { publishSuccess } from "../NewCase/actions";
import { loadMorePosts } from "../../actions";
import { push } from "redux-little-router";
import { notifyPublishSuccess, notifyPublishFailure } from "../../services/slack";
import { setIsJustPublished } from "../../actions/postActions";
import { constructPostSlugPath } from "../../util/index";
import windowDataLayer from "../../util/windowDataLayer";

const GUID_ACTION_BASE = "GET_GUID";
const PUBLISH_ACTION_BASE = "PUBLISH";

function* handleGuidRequest() {
  let request = PostApi.getGUIDUrl();
  try {
    const guid = yield call(api.get, request.url);
    yield put({ type: `${GUID_ACTION_BASE}_SUCCESS`, guid });
  } catch (error) {
    yield put({ type: `${GUID_ACTION_BASE}_FAILED`, error });
  }
}

function* handlePublishRequest({ post }) {
  let request = PostApi.getPublishPostUrl(post);

  try {
    //attempt to publish post
    const publishedPost = yield call(api.post, request.url, request.config);

    //fire success action
    yield put(publishSuccess(post));

    //Announce that we have just published a new post
    yield put(setIsJustPublished());

    //refresh feed
    yield put(loadMorePosts({ override: true }));

    //notify Slack
    let slackNotificationRequest = notifyPublishSuccess(post);
    yield call(api.post, slackNotificationRequest.url, slackNotificationRequest.config);

    windowDataLayer.push({ event: "publish" });

    //redirect to post
    const postRoute = constructPostSlugPath(publishedPost.data);
    yield put(push(postRoute));
  } catch (error) {
    //catch err for tracking
    yield put({ type: `${PUBLISH_ACTION_BASE}_FAILED`, error });

    //show error alert
    yield put(showAlert("Sorry, your case couldn't be published right now. Please try again later", "error"));

    //notify Slack
    let slackNotificationRequest = notifyPublishFailure(post);
    yield call(api.post, slackNotificationRequest.url, slackNotificationRequest.config);
  }
}

export function* watchNewCaseRequests() {
  yield takeLatest(`${PUBLISH_ACTION_BASE}_REQUEST`, handlePublishRequest);
  yield takeLatest(`${GUID_ACTION_BASE}_REQUEST`, handleGuidRequest);
}

export default watchNewCaseRequests;



// WEBPACK FOOTER //
// ./src/scenes/CaseFormContainer/sagas.js